/* eslint jsx-a11y/href-no-hash: "off" */
import React from 'react'

class ArenaSubmissionMenuBackButton extends React.Component {

  handleClick(e) {
    e.preventDefault();

    //Look up my option model
    const optionModel = this.props.menuModel.optionsData[this.props.optionId];

    //Submit my option model through the menu snapshot
    this.props.menuModel.submit(optionModel);
  }

  render() {
    const style = {
      textDecoration: "none",
      color: "#fff"
    };
    const backText = "< ESC";
    return (
      <a style={style} href="#" onClick={this.handleClick.bind(this)}>
        {backText}
      </a>
    );
  }
}


export default ArenaSubmissionMenuBackButton;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaSubmissionMenuBackButton.js